exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box-card[data-v-695ae548] {\n  margin-bottom: 20px;\n}\n.clearfix[data-v-695ae548] {\n  margin-bottom: 10px;\n}\n.role-span[data-v-695ae548] {\n  font-size: 16px;\n  font-weight: bold;\n}\n.el-timeline[data-v-695ae548] {\n  margin: 20px 0;\n}\n.el-card[data-v-695ae548] {\n  margin: 10px 0;\n}\n", ""]);

// exports
